export default __webpack_public_path__ + "static/media/logout.796f2718.svg";